import React from 'react';
interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}
export const PageHeader = ({
  title,
  description,
  actions
}: PageHeaderProps) => {
  return <div className="py-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-46">
      <div data-id="element-47">
        <h1 className="text-xl md:text-2xl font-semibold text-text-primary" data-id="element-48">
          {title}
        </h1>
        {description && <p className="mt-1 text-sm text-text-secondary" data-id="element-49">{description}</p>}
      </div>
      {actions && <div className="flex space-x-3 sm:flex-shrink-0" data-id="element-50">{actions}</div>}
    </div>;
};